import React, { useEffect, useState } from 'react';
import Modal from '../../../../../component/modal/Modal';
import InputSelect from '../../../../../component/inputSelect/InputSelect';
import { toast } from 'react-toastify';
import { ACCOUNTS_STATUS } from '../../../../../utils/constant';
import InputField from '../../../../../component/form/FormInput';
import Button from '../../../../../component/ui/Button';
import infoIcon from '../../../../../assets/image/info.svg';
import {
	createAccount,
	getAccount,
	getAccountType,
	getParentAccountsDropdownList,
	UpdateAccount,
} from '../../../../../services/settings/accounting';
import { Tooltip } from 'react-tooltip';

export default function CreateAccountsModal({
	setSelectedId,
	selectedId,
	isOpenModal,
	setIsOpenModal,
	showMessage,
	getList,
}) {
	const [accounts, setAccounts] = useState({
		account_name: '',
		account_type: '',
		account_code: '',
		parent_account_id: '',
		status: '',
		description: '',
		is_watchlist: false,
	});
	const [accountTypes, setAccountTypes] = useState([]);
	const [parentAccounts, setParentAccounts] = useState([]);
	const [loader, setLoader] = useState(false);
	const [error, setError] = useState({});
	const handleFormData = (key, value, required) => {
		setAccounts((prev) => ({
			...prev,
			[key]: value,
		}));
		if (required) {
			var newError = { ...error };
			if (key === 'account_name') {
				if (value) {
					delete newError[key];
				} else {
					newError[key] = 'Please enter account name in the field';
				}
			}
			if (key === 'account_type') {
				if (value) {
					delete newError[key];
				} else {
					newError[key] = 'Please select account type from the list';
				}
			}

			setError(newError);
		}
	};

	function checkValidation() {
		const newError = { ...error };
		if (
			!accounts.account_type ||
			accounts.account_type === '' ||
			accounts.account_type === undefined
		) {
			newError.account_type = 'Please select account type from the list.';
		} else {
			delete newError.account_type;
		}
		if (
			!accounts.account_name ||
			accounts.account_name === '' ||
			accounts.account_name === undefined
		) {
			newError.account_name = 'Please account name in the field.';
		} else {
			delete newError.account_name;
		}

		if (Object.keys(newError).length > 0) {
			setError(newError);
			return true;
		} else {
			return false;
		}
	}

	const handleAccounts = async () => {
		let isError = checkValidation();
		if (isError) {
			return toast.error('Creating accounts failed! Please fill required fields.');
		} else {
			try {
				setLoader(true);
				const body = {
					account_name: accounts.account_name,
					account_type: accounts.account_type,
					status: accounts.status,
					account_code: accounts.account_code,
					parent_account_id: accounts.parent_account_id,
					description: accounts.description,
					is_watchlist: accounts.is_watchlist,
				};
				let res;
				if (selectedId) {
					res = await UpdateAccount(selectedId, body);
				} else {
					res = await createAccount(body);
				}

				if (res.success) {
					if (showMessage === null) {
						toast.success(res.message);
						setSelectedId(res.data.account_id);
					} else {
						showMessage();
					}
					setIsOpenModal(false);
					getList();
				} else {
					toast.error(res.message || 'somenthing went wrong!');
				}
			} catch (error) {
				toast.error(error.message || 'somenthing went wrong!');
			} finally {
				setLoader(false);
			}
		}
	};

	const getAccountTypes = async () => {
		try {
			const response = await getAccountType();

			const accountTypeList = response.account_types
				.flatMap((item) => item.types)
				.map((type) => ({
					key: type.toLowerCase().replaceAll(' ', '_'),
					value: type,
				}));
			setAccountTypes(accountTypeList);
		} catch (e) {
			console.log(e);
		}
	};
	const getParentAccountList = async () => {
		try {
			const accounts = await getParentAccountsDropdownList();

			const accountList = accounts.map((data) => ({
				key: data.account_id,
				value: data.account_name,
			}));
			setParentAccounts(accountList);
		} catch (e) {
			console.log(e);
		}
	};

	const getAccountDetails = async () => {
		try {
			const res = await getAccount(selectedId);
			const data = {
				account_name: res.account_name,
				account_type: res.account_type,
				account_code: res.account_code || '',
				status: res.status,
				parent_account_id: res.parent_account_id || '',
				description: res.description || '',
				is_watchlist: res.is_watchlist || false,
			};
			setAccounts(data);
		} catch (e) {}
	};

	const resetAccount = () => {
		const data = {
			account_name: '',
			account_type: '',
			account_code: '',
			parent_account: '',
			status: '',
			description: '',
			is_watchlist: false,
		};
		setAccounts(data);
	};

	useEffect(() => {
		if (selectedId) {
			getAccountDetails();
		} else {
			resetAccount();
		}
	}, [selectedId]);

	useEffect(() => {
		if (isOpenModal) {
			getAccountTypes();
		}
	}, [isOpenModal]);

	useEffect(() => {
		if (isOpenModal) {
			getParentAccountList();
		}
	}, [isOpenModal]);

	return (
		<Modal
			className="create-user-model"
			title={selectedId ? 'Edit Account' : 'Add New Account'}
			subtitle={
				'Add a custom account when the default accounts are not enough for your business tracking.'
			}
			isOpen={isOpenModal}
			onClose={() => {
				setIsOpenModal(false);
			}}
			cancelButton={() => {
				setIsOpenModal(false);
			}}
		>
			<div className="row my-3">
				<div className="col-4">
					<InputSelect
						label="Account Type"
						placeholder="Select Account Type"
						name="account_type"
						required={true}
						options={accountTypes}
						returnInputValue={false}
						value={accounts?.account_type}
						tolipIcon={{
							name: 'status',
							icon: infoIcon,
							title: 'Select What kind of account in this',
						}}
						onSelect={(option) => {
							handleFormData('account_type', option.key, true);
						}}
						onChange={(value) => {
							if (value === null || value === '') {
								handleFormData('account_type', value);
							}
						}}
						error={error?.account_type}
					/>
				</div>
				<div className="col-4">
					<InputField
						label="Account Name"
						tolipIcon={{
							name: 'account_name',
							icon: infoIcon,
							title: 'Eg. SBI Current account, Shop, rent expense and Staff advance',
						}}
						name="account_name"
						placeholder="Account Name"
						type="text"
						required={true}
						value={accounts.account_name}
						onChange={(value) => {
							handleFormData('account_name', value, true);
						}}
						error={error?.account_name}
					/>
				</div>
				<div className="col-4">
					<InputField
						label="Account Code"
						tolipIcon={{
							name: 'account_code',
							icon: infoIcon,
							title: 'Optional code for easy tracking',
						}}
						name="account_code"
						placeholder="Account Code"
						type="text"
						required={false}
						value={accounts.account_code}
						onChange={(value) => {
							handleFormData('account_code', value);
						}}
						error={error?.account_code}
					/>
				</div>
				<div className="col-4">
					<InputSelect
						label="Parent Account"
						tolipIcon={{
							name: 'parent_account',
							icon: infoIcon,
							title: 'Select this if the acount belongs under another account.',
						}}
						placeholder="Select Parent Account"
						name="parent_account"
						required={false}
						options={parentAccounts}
						returnInputValue={false}
						value={accounts?.parent_account_id}
						onSelect={(option) => {
							handleFormData('parent_account_id', option.key);
						}}
						onChange={(value) => {
							if (value === null || value === '') {
								handleFormData('parent_account_id', value);
							}
						}}
						error={error?.parent_account_id}
					/>
				</div>
				<div className="col-4">
					<InputSelect
						label="Status"
						tolipIcon={{
							name: 'status',
							icon: infoIcon,
							title: 'Active Account can be use in the transaction',
						}}
						placeholder="Status"
						name="status"
						required={false}
						options={ACCOUNTS_STATUS}
						returnInputValue={false}
						value={accounts?.status}
						onSelect={(option) => {
							handleFormData('status', option.key);
						}}
						onChange={(value) => {
							if (value === null || value === '') {
								handleFormData('status', value);
							}
						}}
						error={error?.status}
					/>
				</div>
				<div className="col-4">
					<div className="d-flex gap-3 align-items-center my-5 py-2">
						<div className="form-check">
							<input
								class="form-check-input"
								type="checkbox"
								checked={accounts?.is_watchlist}
								id="flexCheckDefault"
								onChange={(e) => handleFormData('is_watchlist', !accounts?.is_watchlist)}
							/>
						</div>
						<div className="d-flex gap-3 align-items-center">
							<div className="fs-4 fw-bold text-dark">Add to Watchlist</div>

							<>
								<img
									src={infoIcon}
									alt="info"
									width={15}
									height={15}
									data-tooltip-id={`tooltip-watchlist`}
									data-tooltip-content={'Show this account on dashboard/watchlist'}
									className="cursor-pointer"
								/>

								<Tooltip id={`tooltip-watchlist`} />
							</>
						</div>
					</div>
				</div>
				<div className="col-12">
					<InputField
						type="text"
						tolipIcon={{
							name: 'status',
							icon: infoIcon,
							title: 'Write what this account will be used for',
						}}
						value={accounts?.description}
						placeholder="Description"
						label="Description"
						multiline={true}
						rows={2}
						onChange={(value) => handleFormData('description', value)}
						error={error?.description}
						autoComplete="off"
					/>
				</div>
			</div>
			<div className="d-flex align-items-center justify-content-end mt-3 gap-4">
				<Button
					type="button"
					button={selectedId ? `Update` : `Save`}
					className="mt-0 px-4 btn-primary relative"
					loader={loader}
					disabled={loader}
					onClick={() => handleAccounts()}
				/>
				<Button
					type="button"
					button={`Cancel`}
					className="mt-0 px-4 btn-gray relative"
					onClick={() => {
						setIsOpenModal(false);
					}}
				/>
			</div>
		</Modal>
	);
}
